/**
 * Vanilla Smart Select - Browser build with styles
 * This file is used for UMD builds that include CSS
 */

import VanillaSmartSelect from "./index.js";

// Import styles (only for browser builds)
import "./styles/vanilla-smart-select.css";

export default VanillaSmartSelect;
export * from "./index.js";
